import utils from "@/utils"
import Vue from "vue"

const vue = new Vue()

export const FacebookLoginStatus = {
    "CONNECTED": "connected",
    "UNAUTHORIZED": "not_authorized",
    "UNKNOWN": "unknown"
}

export default {
    sdkLoaded: null,
    initialize() {
        let promise = utils.createPromise()
        this.sdkLoaded = promise.promise
        if (window["FB"]) {
            this.configureSDK()
            promise.resolve()
        } else {
            window["fbAsyncInit"] = () => {
                this.configureSDK()
                delete window['fbAsyncInit']
                promise.resolve()
            }
        }
    },
    configureSDK() {
        window["FB"].init({
            appId: "4630264813711537",
            autoLogAppEvents: true,
            xfbml: false,
            version: "v9.0"
        })
    },
    async authenticate() {
        try {
            const loginStatus = await this.getLoginStatus()
            if (loginStatus.status == FacebookLoginStatus.CONNECTED) {
                return loginStatus.authResponse
            } else {
                return this.showAuthDialog()
            }
        } catch (e) {
            vue.bugsnag.notify(
                "Failed to Login with FB",
                (event) => {
                    event.addMetadata("reason", {
                        error: e
                    })
                }
            )
            return false
        }
    },
    async getLoginStatus(refresh) {
        try {
            await this.sdkLoaded
            const promise = utils.createPromise()
            window.FB.getLoginStatus((response) => {
                vue.bugsnag.leaveBreadcrumb(
                    "Got Facebook Login Status",
                    {
                        status: response.status
                    }
                )
                promise.resolve(response)
            }, refresh)
            return promise.promise
        } catch (e) {
            vue.bugsnag.notify(
                "Failed to Login Status",
                (event) => {
                    event.addMetadata("reason", {
                        error: e
                    })
                }
            )
            return false
        }
    },
    async showAuthDialog() {
        try {
            await this.sdkLoaded
            vue.bugsnag.leaveBreadcrumb("Showing Auth Dialog")
            const promise = utils.createPromise()
            window.FB.login((response) => {
                vue.bugsnag.leaveBreadcrumb("Got FB Login Response", {
                    status: response.status
                })
                if (response.status == FacebookLoginStatus.CONNECTED) {
                    promise.resolve(response.authResponse)
                } else {
                    promise.resolve(false)
                }
            }, { scope: "public_profile,email" })
            return promise.promise
        } catch (e) {
            vue.bugsnag.notify(
                "Failed to show auth dialog",
                (event) => {
                    event.addMetadata("reason", {
                        error: e
                    })
                }
            )
            return false
        }
    }
}